import { type Props as DocumentCreateInput } from '@/hooks/mutation/useMutateCreateDocument';
import { GenerationMethod } from '@heidi/schema/ml-scribe';
import { atom } from 'jotai';

export enum QuotaExceedType {
  NONE = 'NONE',
  ASK_AI = 'ASK_AI',
  CHANGE_DOCUMENT_TEMPLATE = 'CHANGE_DOCUMENT_TEMPLATE',
  CREATE_DOCUMENT = 'CREATE_DOCUMENT',
  CREATE_DOCUMENT_FROM_NOTE = 'CREATE_DOCUMENT_FROM_NOTE',
  REGENERATE_DOCUMENT = 'REGENERATE_DOCUMENT',
  STREAM_NOTE = 'STREAM_NOTE',
}

export const shouldShowDelayUpgradeModal = atom<boolean>(false);

export const delayUpgradeExtendAction = atom<QuotaExceedType>(QuotaExceedType.NONE);
export const documentCreateInputBeforeDelay = atom<DocumentCreateInput>({
  generationMethod: GenerationMethod.TEMPLATE,
});
